
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M6.99999 6.11994C6.56999 5.76994 5.93999 5.81994 5.58999 6.24994L1.34999 11.3599C1.03999 11.7299 1.03999 12.2699 1.34999 12.6399L5.58999 17.7499C5.93999 18.1799 6.56999 18.2299 6.99999 17.8799C7.42999 17.5299 7.47999 16.8999 7.12999 16.4699L3.41999 11.9999L7.12999 7.52994C7.47999 7.09994 7.42999 6.46994 6.99999 6.11994ZM6.99999 12.9999H8.99999V10.9999H6.99999V12.9999ZM17 10.9999H15V12.9999H17V10.9999ZM11 12.9999H13V10.9999H11V12.9999ZM17 6.11994C16.57 6.46994 16.52 7.09994 16.87 7.52994L20.58 11.9999L16.87 16.4699C16.52 16.8999 16.58 17.5299 17 17.8799C17.43 18.2299 18.06 18.1799 18.41 17.7499L22.65 12.6399C22.96 12.2699 22.96 11.7299 22.65 11.3599L18.41 6.24994C18.06 5.82994 17.42 5.76994 17 6.11994Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-settings-ethernet`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconSettingsEthernet

    ```js
    <b-new-b-icon-settings-ethernet />
    ```
</docs>


